// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mmmsg-page-head {
    margin-bottom: 16px;
}

.mmmsg-layout {
    display: grid;
    grid-template-columns: minmax(220px, 280px) minmax(0, 1fr) minmax(220px, 280px);
    gap: 16px;
    align-items: stretch;
    min-height: 480px;
}

.mmmsg-list,
.mmmsg-main,
.mmmsg-sidebar {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    padding: 16px;
    min-height: 0;
}

.mmmsg-main {
    display: flex;
    flex-direction: column;
}

.mmmsg-pane-title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--md-muted, #64748b);
    margin: 0 0 12px;
}

.mmmsg-list-ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.mmmsg-list-card {
    width: 100%;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    text-align: left;
    border: 1px solid transparent;
    background: #f8fafc;
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;
}

.mmmsg-list-card:disabled {
    cursor: default;
    opacity: 0.7;
}

.mmmsg-list-card.is-selected {
    border-color: var(--md-blue, #1d4ed8);
    background: #eff6ff;
}

.mmmsg-list-body {
    min-width: 0;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.mmmsg-list-top {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    align-items: baseline;
}

.mmmsg-list-name {
    font-weight: 600;
    color: var(--md-ink, #0f172a);
    font-size: 14px;
}

.mmmsg-list-time {
    font-size: 11px;
    color: var(--md-muted, #64748b);
    flex-shrink: 0;
}

.mmmsg-list-preview {
    font-size: 12px;
    color: var(--md-muted, #64748b);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mmmsg-thread {
    flex: 1 1;
    min-height: 240px;
    display: flex;
    flex-direction: column;
}

.mmmsg-bubbles {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: auto;
    flex: 1 1;
}

.mmmsg-bubble-row {
    display: flex;
    flex-direction: column;
    max-width: 80%;
}

.mmmsg-bubble-row.is-mine {
    align-self: flex-end;
    align-items: flex-end;
}

.mmmsg-bubble-row.is-theirs {
    align-self: flex-start;
    align-items: flex-start;
}

.mmmsg-bubble {
    background: #f1f5f9;
    color: var(--md-ink, #0f172a);
    border-radius: 12px;
    padding: 8px 12px;
    font-size: 14px;
    white-space: pre-wrap;
    word-break: break-word;
}

.mmmsg-bubble.is-mine {
    background: var(--md-blue, #1d4ed8);
    color: #fff;
}

.mmmsg-bubble-time {
    font-size: 11px;
    color: var(--md-muted, #64748b);
    margin-top: 2px;
}

.mmmsg-empty-thread,
.mmmsg-muted {
    color: var(--md-muted, #64748b);
    font-size: 14px;
    margin: 12px 0;
}

.mmmsg-error {
    color: var(--md-red, #dc2626);
    font-size: 13px;
    margin: 0 0 8px;
}

.mmmsg-composer {
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid var(--md-line, #e2e8f0);
}

.mmmsg-composer-row {
    display: flex;
    gap: 8px;
}

.mmmsg-side-name {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--md-ink, #0f172a);
}

.mmmsg-side-label {
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-weight: 700;
    color: var(--md-muted, #64748b);
    margin: 14px 0 4px;
}

.mmmsg-side-body {
    font-size: 14px;
    margin: 0 0 8px;
    color: var(--md-ink, #0f172a);
}

.mmmsg-unavailable {
    color: var(--md-red, #dc2626);
}

@media (max-width: 991px) {
    .mmmsg-layout {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentorMessages.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+EAA+E;IAC/E,SAAS;IACT,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;;IAGI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;;IAEI,+BAA+B;IAC/B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".mmmsg-page-head {\n    margin-bottom: 16px;\n}\n\n.mmmsg-layout {\n    display: grid;\n    grid-template-columns: minmax(220px, 280px) minmax(0, 1fr) minmax(220px, 280px);\n    gap: 16px;\n    align-items: stretch;\n    min-height: 480px;\n}\n\n.mmmsg-list,\n.mmmsg-main,\n.mmmsg-sidebar {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    padding: 16px;\n    min-height: 0;\n}\n\n.mmmsg-main {\n    display: flex;\n    flex-direction: column;\n}\n\n.mmmsg-pane-title {\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--md-muted, #64748b);\n    margin: 0 0 12px;\n}\n\n.mmmsg-list-ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.mmmsg-list-card {\n    width: 100%;\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n    text-align: left;\n    border: 1px solid transparent;\n    background: #f8fafc;\n    border-radius: 10px;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.mmmsg-list-card:disabled {\n    cursor: default;\n    opacity: 0.7;\n}\n\n.mmmsg-list-card.is-selected {\n    border-color: var(--md-blue, #1d4ed8);\n    background: #eff6ff;\n}\n\n.mmmsg-list-body {\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.mmmsg-list-top {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    align-items: baseline;\n}\n\n.mmmsg-list-name {\n    font-weight: 600;\n    color: var(--md-ink, #0f172a);\n    font-size: 14px;\n}\n\n.mmmsg-list-time {\n    font-size: 11px;\n    color: var(--md-muted, #64748b);\n    flex-shrink: 0;\n}\n\n.mmmsg-list-preview {\n    font-size: 12px;\n    color: var(--md-muted, #64748b);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.mmmsg-thread {\n    flex: 1;\n    min-height: 240px;\n    display: flex;\n    flex-direction: column;\n}\n\n.mmmsg-bubbles {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow: auto;\n    flex: 1;\n}\n\n.mmmsg-bubble-row {\n    display: flex;\n    flex-direction: column;\n    max-width: 80%;\n}\n\n.mmmsg-bubble-row.is-mine {\n    align-self: flex-end;\n    align-items: flex-end;\n}\n\n.mmmsg-bubble-row.is-theirs {\n    align-self: flex-start;\n    align-items: flex-start;\n}\n\n.mmmsg-bubble {\n    background: #f1f5f9;\n    color: var(--md-ink, #0f172a);\n    border-radius: 12px;\n    padding: 8px 12px;\n    font-size: 14px;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.mmmsg-bubble.is-mine {\n    background: var(--md-blue, #1d4ed8);\n    color: #fff;\n}\n\n.mmmsg-bubble-time {\n    font-size: 11px;\n    color: var(--md-muted, #64748b);\n    margin-top: 2px;\n}\n\n.mmmsg-empty-thread,\n.mmmsg-muted {\n    color: var(--md-muted, #64748b);\n    font-size: 14px;\n    margin: 12px 0;\n}\n\n.mmmsg-error {\n    color: var(--md-red, #dc2626);\n    font-size: 13px;\n    margin: 0 0 8px;\n}\n\n.mmmsg-composer {\n    margin-top: auto;\n    padding-top: 12px;\n    border-top: 1px solid var(--md-line, #e2e8f0);\n}\n\n.mmmsg-composer-row {\n    display: flex;\n    gap: 8px;\n}\n\n.mmmsg-side-name {\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mmmsg-side-label {\n    font-size: 11px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: var(--md-muted, #64748b);\n    margin: 14px 0 4px;\n}\n\n.mmmsg-side-body {\n    font-size: 14px;\n    margin: 0 0 8px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mmmsg-unavailable {\n    color: var(--md-red, #dc2626);\n}\n\n@media (max-width: 991px) {\n    .mmmsg-layout {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
